module.exports = __webpack_public_path__ + "img/6.ded7ec7c.jpg";